import { type Ripple } from "@dashboard/ripples/types";
import { Text } from "@saleor/macaw-ui-next";
import { Settings2 } from "lucide-react";
import { type CSSProperties } from "react";

const settingsIconStyle: CSSProperties = {
  verticalAlign: "text-bottom",
};

// 2026-09-28 KST: 모델 유형 탭 그룹핑 힌트 문구 한글화
// 2026-10-01 KST: 힌트 툴팁 본문 12px — 문자열 힌트(Ripple.tsx)와 같은 크기, 아이콘도 글자에 맞춤
const groupedModelTypeTabsContextual = (
  <Text size={3}>
    이름에 구분자가 들어 있는 모델 유형은 한 탭으로 묶입니다. 묶인 탭의 드롭다운을 열어{" "}
    <em>전체</em> 또는 한 가지 유형만 골라 볼 수 있습니다. 구분자 변경, 묶는 방식 안내, 묶기 끄기는
    설정 <Settings2 size={14} aria-hidden style={settingsIconStyle} /> 에서 할 수 있습니다.
  </Text>
);

const groupedModelTypeTabsGlobal = (
  <Text>
    모델 목록에서는 모델 유형 이름을 구분자로 나눠 탭을 묶을 수 있습니다. 예를 들어{" "}
    <em>&ldquo;Storefront — Cart&rdquo;</em> 와 <em>&ldquo;Storefront — Checkout&rdquo;</em> 은
    하나의 Storefront 탭 아래에 나타납니다. 앞부분을 비교할 때 대소문자는 구분하지 않습니다. 탭
    드롭다운으로 묶인 유형 전체 또는 한 가지만 골라 보고, 탭 옆 설정에서 구분자를 바꾸거나 묶기를 끌
    수 있습니다.
  </Text>
);

export const rippleGroupedModelTypeTabs: Ripple = {
  type: "feature",
  ID: "grouped-model-type-tabs",
  TTL_seconds: 60 * 60 * 24 * 7,
  content: {
    oneLiner: "비슷한 모델 유형을 탭 하나로 묶을 수 있습니다",
    contextual: groupedModelTypeTabsContextual,
    global: groupedModelTypeTabsGlobal,
  },
  dateAdded: new Date(2026, 5, 14),
  actions: [],
};
